module.exports = __webpack_public_path__ + "fonts/opensans-regular.8a57d180.ttf";